export default __webpack_public_path__ + "static/media/1.53f0fb0d.png";